<template>
  <div class="setting-page">
    <div class="header">
      <div class="header-back" @click="$router.back()">
        <svg viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="none" stroke="#fff" stroke-width="2">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </div>
      <div class="header-title">个人资料</div>
    </div>

    <div class="profile-top">
      <div class="avatar-wrap">
        <div class="avatar">
          <img :src="userInfo.avatar || '/static/newImg/mine/img_ntx6.avif'" class="avatar-img" />
          <div class="avatar-badge">
            <svg viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="#d1ae52">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="profile-info">
        <div class="profile-id">
          <span>ID: {{ userInfo.id || '-' }}</span>
          <svg viewBox="0 0 24 24" width="0.35rem" height="0.35rem" fill="#d1ae52">
            <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
          </svg>
        </div>
        <div class="profile-nickname">
          <span>昵称: {{ userInfo.username || '请输入昵称' }}</span>
          <svg viewBox="0 0 24 24" width="0.35rem" height="0.35rem" fill="#d1ae52">
            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
          </svg>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="section-title">默认展示信息</div>
      <div class="form-row" @click="showDefaultSelect = !showDefaultSelect">
        <svg v-if="displayType === 'nickname'" class="row-icon" viewBox="0 0 24 24" width="0.55rem" height="0.55rem" fill="#999">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
        </svg>
        <span class="row-value">{{ displayText }}</span>
        <svg class="row-arrow" :class="{ rotate: showDefaultSelect }" viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="none" stroke="#666" stroke-width="2">
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </div>
      <div class="select-dropdown" v-if="showDefaultSelect">
        <div class="select-option-item" @click="selectDisplay('nickname')">
          <svg class="select-icon" viewBox="0 0 24 24" width="0.55rem" height="0.55rem" fill="#d1ae52">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
          </svg>
          <span class="select-option-name" :class="{ active: displayType === 'nickname' }">{{ userInfo.username || '-' }}</span>
        </div>
        <div class="select-option-id" @click="selectDisplay('id')">ID {{ userInfo.id || '-' }}</div>
      </div>
    </div>

    <div class="form-section">
      <div class="section-title">绑定手机</div>
      <div class="form-row">
        <svg class="row-icon" viewBox="0 0 24 24" width="0.55rem" height="0.55rem" fill="#999">
          <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>
        </svg>
        <span class="row-placeholder">{{ userInfo.mobile ? userInfo.mobile : '请绑定手机' }}</span>
        <span class="row-link" @click="goToBind">{{ userInfo.mobile ? '修改' : '去绑定' }}</span>
      </div>
    </div>

    <div class="form-section">
      <div class="section-title">第三方账号绑定</div>
      <div class="form-row form-row-input" :class="{ focused: wechatFocused }">
        <svg class="row-icon wechat-icon" viewBox="0 0 24 24" width="0.45rem" height="0.45rem" fill="#07c160">
          <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 0 1 .598.082l1.584.926a.272.272 0 0 0 .14.047c.134 0 .24-.111.24-.247 0-.06-.023-.12-.038-.177l-.327-1.233a.582.582 0 0 1-.023-.156.49.49 0 0 1 .201-.398C23.024 18.48 24 16.82 24 14.98c0-3.21-2.931-5.837-6.656-6.088V8.89c-.135-.01-.27-.027-.407-.03zm-2.53 3.274c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.97-.982zm4.844 0c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.969-.982z"/>
        </svg>
        <input class="row-input" type="text" placeholder="请输入微信号" v-model="wechatId" @focus="wechatFocused = true" @blur="wechatFocused = false" />
      </div>
    </div>

    <div class="form-section">
      <div class="section-title">生日<span class="section-sub">(设置后不能修改)</span></div>
      <div class="form-row" @click="showBirthdayPicker = true">
        <span class="row-value">{{ birthdayText }}</span>
        <svg class="row-arrow" :class="{ rotate: showBirthdayPicker }" viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="none" stroke="#666" stroke-width="2">
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </div>
    </div>

    <div class="age-warning">
      系统要求满18周岁才能使用，即2008/07/14前出生！
    </div>

    <!-- 日期选择器 -->
    <div class="date-picker-mask" v-if="showBirthdayPicker" @click.self="showBirthdayPicker = false">
      <div class="date-picker">
        <div class="date-picker-header">
          <span class="date-picker-cancel" @click="showBirthdayPicker = false">取消</span>
          <span class="date-picker-title">选择日期</span>
          <span class="date-picker-confirm" @click="confirmBirthday">确定</span>
        </div>
        <div class="date-picker-body">
          <div class="date-col" ref="yearCol">
            <div class="date-col-scroll" :style="{ transform: `translateY(${yearOffset}px)` }">
              <div class="date-item" v-for="y in years" :key="y" :class="{ active: y === selectedYear }" @click="selectedYear = y">{{ y }}</div>
            </div>
          </div>
          <div class="date-col" ref="monthCol">
            <div class="date-col-scroll" :style="{ transform: `translateY(${monthOffset}px)` }">
              <div class="date-item" v-for="m in months" :key="m" :class="{ active: m === selectedMonth }" @click="selectedMonth = m">{{ String(m).padStart(2, '0') }}</div>
            </div>
          </div>
          <div class="date-col" ref="dayCol">
            <div class="date-col-scroll" :style="{ transform: `translateY(${dayOffset}px)` }">
              <div class="date-item" v-for="d in days" :key="d" :class="{ active: d === selectedDay }" @click="selectedDay = d">{{ String(d).padStart(2, '0') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-btns">
      <div class="btn-back" @click="$router.back()">返回</div>
      <div class="btn-save" @click="handleSave">保存</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Setting',
  data() {
    const now = new Date()
    return {
      userInfo: {},
      birthdayChanged: false,
      showDefaultSelect: false,
      displayType: 'nickname',
      showBirthdayPicker: false,
      wechatId: '',
      wechatFocused: false,
      selectedYear: 2000,
      selectedMonth: 1,
      selectedDay: 1,
      years: Array.from({ length: 80 }, (_, i) => 2008 - i),
      months: Array.from({ length: 12 }, (_, i) => i + 1),
      days: Array.from({ length: 31 }, (_, i) => i + 1),
      itemHeight: 40
    }
  },
  created() {
    this.loadUserInfo()
  },
  computed: {
    displayText() {
      if (this.displayType === 'id') {
        return 'ID ' + (this.userInfo.id || '-')
      }
      return this.userInfo.username || '-'
    },
    birthdayText() {
      if (this.birthdayChanged) {
        return `${this.selectedYear}-${String(this.selectedMonth).padStart(2, '0')}-${String(this.selectedDay).padStart(2, '0')}`
      }
      if (this.userInfo.birthday) {
        return this.userInfo.birthday
      }
      return '年 月 日'
    },
    yearOffset() {
      const idx = this.years.indexOf(this.selectedYear)
      return -(idx * this.itemHeight) + 60
    },
    monthOffset() {
      const idx = this.months.indexOf(this.selectedMonth)
      return -(idx * this.itemHeight) + 60
    },
    dayOffset() {
      const idx = this.days.indexOf(this.selectedDay)
      return -(idx * this.itemHeight) + 60
    }
  },
  methods: {
    loadUserInfo() {
      this.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data
          this.wechatId = res.data.wechat || ''
        }
      })
    },
    selectDisplay(type) {
      this.displayType = type
      this.showDefaultSelect = false
    },
    goToBind() {
      this.$router.push({ path: '/security', query: { active: '0' } })
    },
    confirmBirthday() {
      this.showBirthdayPicker = false
      this.birthdayChanged = true
    },
    handleSave() {
      const birthday = `${this.selectedYear}-${String(this.selectedMonth).padStart(2, '0')}-${String(this.selectedDay).padStart(2, '0')}`
      this.$apiFun.post('/api/updateuserinfo', {
        birthday: birthday,
        mobile: this.userInfo.mobile || '',
        email: this.userInfo.email || '',
        wechat: this.wechatId || ''
      }).then(res => {
        if (res.code === 200) {
          this.$toast && this.$toast('保存成功')
          setTimeout(() => { this.$router.back() }, 1000)
        } else {
          this.$toast && this.$toast(res.msg || '保存失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.setting-page {
  min-height: 100vh;
  background: #111;
  color: #fff;
  padding-bottom: 1.5rem;
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem;
  position: relative;
}

.header-back {
  position: absolute;
  left: 0.3rem;
}

.header-title {
  font-size: 0.4rem;
  font-weight: bold;
}

.profile-top {
  display: flex;
  align-items: center;
  padding: 0.3rem;
  gap: 0.3rem;
}

.avatar-wrap {
  flex-shrink: 0;
}

.avatar {
  position: relative;
  width: 1.2rem;
  height: 1.2rem;
}

.avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.avatar-badge {
  position: absolute;
  bottom: 0;
  right: 0;
  background: #111;
  border-radius: 50%;
  width: 0.45rem;
  height: 0.45rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-info {
  flex: 1;
}

.profile-id {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  font-size: 0.32rem;
  color: #ccc;
  margin-bottom: 0.15rem;
}

.profile-nickname {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  font-size: 0.32rem;
  color: #ccc;
}

.form-section {
  margin: 0 0.3rem;
  margin-bottom: 0.3rem;
}

.section-title {
  font-size: 0.35rem;
  color: #fff;
  margin-bottom: 0.2rem;
}

.section-sub {
  font-size: 0.28rem;
  color: #666;
}

.form-row {
  display: flex;
  align-items: center;
  background: #1a1a1a;
  border: 1px solid #666;
  border-radius: 0.15rem;
  padding: 0.25rem 0.3rem;
  gap: 0.2rem;
}

.form-row-input {
  border: 1px solid #666;
  transition: border-color 0.2s;
}

.form-row-input.focused {
  border-color: #d1ae52;
}

.row-icon {
  flex-shrink: 0;
}

.row-placeholder {
  flex: 1;
  font-size: 0.32rem;
  color: #999;
}

.row-value {
  flex: 1;
  font-size: 0.32rem;
  color: #fff;
}

.row-link {
  font-size: 0.32rem;
  color: #d1ae52;
  flex-shrink: 0;
  cursor: pointer;
}

.row-arrow {
  flex-shrink: 0;
  transition: transform 0.3s;
}

.row-arrow.rotate {
  transform: rotate(180deg);
}

.wechat-icon {
  fill: #07c160;
}

.row-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 0.32rem;
}

.row-input::placeholder {
  color: #666;
}

.select-dropdown {
  background: #1a1a1a;
  border: 1px solid #666;
  border-radius: 0.15rem;
  margin-top: 0.1rem;
  overflow: hidden;
  padding: 0.25rem 0.3rem;
}

.select-option-item {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  padding-bottom: 0.2rem;
  border-bottom: 1px solid #333;
}

.select-icon {
  flex-shrink: 0;
}

.select-option-name {
  font-size: 0.35rem;
  color: #d1ae52;
  font-weight: bold;
}

.select-option-name.active {
  color: #d1ae52;
}

.select-option-id {
  padding-top: 0.2rem;
  font-size: 0.32rem;
  color: #999;
  cursor: pointer;
}

.age-warning {
  margin: 0 0.3rem;
  font-size: 0.3rem;
  color: #ffaa09;
}

.bottom-btns {
  position: fixed;
  bottom: 0.5rem;
  left: 0.3rem;
  right: 0.3rem;
  display: flex;
  gap: 0.3rem;
}

.btn-back {
  flex: 1;
  padding: 0.3rem;
  background: transparent;
  border: 1px solid #d1ae52;
  color: #d1ae52;
  text-align: center;
  font-size: 0.35rem;
  font-weight: normal;
  border-radius: 0.1rem;
  cursor: pointer;
}

.btn-save {
  flex: 1;
  padding: 0.3rem;
  background: #d1ae52;
  color: #000;
  text-align: center;
  font-size: 0.35rem;
  font-weight: normal;
  border-radius: 0.1rem;
  cursor: pointer;
}

/* 日期选择器 */
.date-picker-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: flex-end;
}

.date-picker {
  width: 100%;
  background: #1a1a1a;
  border-radius: 0.3rem 0.3rem 0 0;
}

.date-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem;
  border-bottom: 1px solid #333;
}

.date-picker-cancel {
  font-size: 0.32rem;
  color: #999;
  cursor: pointer;
}

.date-picker-title {
  font-size: 0.35rem;
  color: #fff;
  font-weight: bold;
}

.date-picker-confirm {
  font-size: 0.32rem;
  color: #d1ae52;
  cursor: pointer;
}

.date-picker-body {
  display: flex;
  height: 4rem;
  overflow: hidden;
  position: relative;
}

.date-picker-body::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: #333;
  transform: translateY(-50%);
  z-index: 1;
}

.date-picker-body::after {
  content: '';
  position: absolute;
  top: calc(50% - 0.5rem);
  left: 0;
  right: 0;
  height: 1rem;
  border-top: 1px solid #333;
  border-bottom: 1px solid #333;
  z-index: 1;
  pointer-events: none;
}

.date-col {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.date-col-scroll {
  transition: transform 0.3s ease;
}

.date-item {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 0.35rem;
  color: #666;
}

.date-item.active {
  color: #fff;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/view/setting/setting.vue